module.exports = "<div class=\"form-group typeahead-wrapper\"> <app-widgets-searchbox config=$ctrl.config> <custom-search> <input type=text autocomplete=off class=form-control minlength=1 maxlength=100 name=photo-search clear-on-select=true app-widgets-searchbox-input trigger-focus=$parent.$ctrl.isInputFocused placeholder=\"{{ ::$ctrl.placeholder }}\" ngeo-search=$parent.$ctrl.options ngeo-search-datasets=$parent.$ctrl.datasets ngeo-search-listeners=$parent.$ctrl.listeners> </custom-search> </app-widgets-searchbox> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/photo/search/partial.html
// module id = 422
// module chunks = 0